import { render } from "./FlashMessage.vue?vue&type=template&id=4ba8d58c"
import script from "./FlashMessage.vue?vue&type=script&lang=js"
export * from "./FlashMessage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/MearnsGill/Sites/ICoTA/icota-europe.localhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__